import Http from "../../http/client";

export default async (userId, page) => {
  const response = await Http.get(`admin/trip/driver/${userId}/payments`, {
    params: { page },
  });

  return response.data;
};
